import React, { useState } from 'react';
import { Header } from './Header';
import { Problem } from './Problem';
import { Solution } from './Solution';
import { Testimonials } from './Testimonials';
import { Reviews } from './Reviews';
import { WebinarDetails } from './WebinarDetails';
import { FAQ } from './FAQ';
import { Benefits } from './Benefits';
import { CallToAction } from './CallToAction';
import { MoreTestimonials } from './MoreTestimonials';
import { Footer } from './Footer';
import { WebinarModal } from './WebinarModal';
import { StickyWebinarButton } from './StickyWebinarButton';
export const Advertorial = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Changed the URL in openModal function as per the comment
  const openModal = () => {
    window.location.href = 'https://stresslessdogs.nl/mcc-gpm-adv1';
  };
  const closeModal = () => setIsModalOpen(false);
  return <div className="max-w-3xl mx-auto px-4 py-6 font-sans text-gray-800" data-id="element-9">
      <WebinarModal isOpen={isModalOpen} onClose={closeModal} data-id="element-10" />
      <StickyWebinarButton targetHeadingText="Gedragsdeskundige Amee: Straffen zorgt voor stress, stress zorgt voor problemen" data-id="element-11" />
      <Header openModal={openModal} data-id="element-12" />
      <Problem openModal={openModal} data-id="element-13" />
      <Solution openModal={openModal} data-id="element-14" />
      <Testimonials openModal={openModal} data-id="element-15" />
      <WebinarDetails openModal={openModal} data-id="element-16" />
      <Reviews openModal={openModal} data-id="element-17" />
      <FAQ openModal={openModal} data-id="element-18" />
      <Benefits openModal={openModal} data-id="element-19" />
      <CallToAction openModal={openModal} data-id="element-20" />
      <MoreTestimonials openModal={openModal} data-id="element-21" />
      <div className="mb-8 text-center" data-id="element-22">
        <button onClick={openModal} className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition duration-200" data-id="element-23">
          Klik hier voor meer informatie over het webinar
        </button>
      </div>
      <Footer openModal={openModal} data-id="element-24" />
    </div>;
};